import { useMemo } from 'react'
import * as Yup from 'yup'

export function useValidationSchema() {
  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      __type: Yup.mixed().oneOf(['LogoFormValues']),
      logoName: Yup.string().required(),
      logoDesignFile: Yup.string(),
      logoImageSource: Yup.string().required(),
      logoPlacement: Yup.object().shape({}).notRequired(),
    })
  }, [])

  return validationSchema
}
